import { ActionContext, ActionTree, GetterTree } from "vuex";
import { OptionData } from "@/model/Option";
import { deepCopy } from "@/service/util";

const initialState: OptionData = {
  option: {
    subTotalZn: 0,
    subTotalZk: 0
  },
  isConfirm: 0
};
const actions: ActionTree<OptionData, any> = {
  setOption(
    { commit }: ActionContext<OptionData, any>,
    payload: OptionData
  ): void {
    commit("setOption", payload);
  },
  confirm({ commit }: ActionContext<OptionData, any>, payload: number): void {
    commit("confirm", payload);
  },
  clearState({ commit }: ActionContext<OptionData, any>): void {
    commit("clearState");
  },
  updateSubTotal({ commit }: ActionContext<OptionData, any>, payload: any): void {
    commit("updateSubTotal", payload);
  }
};

const mutations = {
  setOption(state: OptionData, payload: OptionData) {
    if (payload.option && payload.option.items) {
      payload.option.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? 1 : 0)
      );
    }
    state.optionOld = deepCopy(state.option);
    Object.assign(state, payload);
  },
  confirm(state: OptionData, payload: number) {
    state.isConfirm = payload;
  },
  clearState(state: OptionData) {
    Object.assign(state, { ...initialState });
  },
  updateSubTotal(state: OptionData, payload: any) {
    if (state.option) {
      state.option.subTotalZk = payload.subTotalZk;
      state.option.subTotalZn = payload.subTotalZn;
    }
  }
};

const getters: GetterTree<OptionData, any> = {
  hasData(state: OptionData) {
    if (state.option && state.option.items) {
      return true;
    }
    return false;
  },
  currentState(state: OptionData) {
    if (state.option && state.option.items) {
      state.option.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? 1 : 0)
      );
    }
    return state;
  },
  currentStateForShow(state: OptionData) {
    if (state.option && state.option.items) {
      state.option.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? true : false)
      );
    }
    return state;
  },
  total(state: OptionData) {
    if (state.option) {
      const { subTotalZn, subTotalZk, items } = state.option;
      return { subTotalZn, subTotalZk, isConfirm: state.isConfirm, items };
    }
    return null;
  },
  isConfirm(state: OptionData) {
    return state.isConfirm;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
